import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { ProdutoPizzaLasanhaComEmpresa, ProdutoPizzaLasanhaQtdSabores, ProdutosPizzaLasanhaComEmpresa, Tamanho } from 'src/app/shared/models/produto.model';
import { PizzaLasanhaGrid } from './pizza-lasanha-grid.viewmodel';
import { ValoresPorSabor } from 'src/app/shared/components/integracao-pizza-lasanha/integracao-pizza-lasanha.viewmodel';
import { ModalController } from '@ionic/angular';
import { QtdSaboresFatiasComponent } from 'src/app/shared/components/qtd-sabores-fatias/qtd-sabores-fatias.component';
import { TipoPrecoEnum } from 'src/app/shared/enums/tipo-preco.enum';

@Component({
    selector: 'app-grid-pizzas-lasanhas',
    templateUrl: './grid-pizzas-lasanhas.component.html',
    styleUrls: ['./grid-pizzas-lasanhas.component.scss'],
})
export class GridPizzasLasanhasComponent implements OnChanges {
    @ViewChildren('campoAcrescimo') inputs!: QueryList<ElementRef>;

    @Input() pizzaLasanha: PizzaLasanhaGrid[] = [];
    @Input() tamanhos: Tamanho[];
    @Input() indexItemSelecionado: number = -1;
    @Input() sabores: string[] = [];
    @Input() produtosPizzaLasanhaQtdSabores: ProdutoPizzaLasanhaQtdSabores[] = [];
    @Input() tipoPreco: TipoPrecoEnum = TipoPrecoEnum.Padrao;

    @Output() alterarIndexItemSelecionado = new EventEmitter<number>();
    @Output() checkedPizzaLasanha = new EventEmitter<ProdutosPizzaLasanhaComEmpresa>();
    @Output() alterarPizza = new EventEmitter<ValoresPorSabor>();
    @Output() pizzaLasanhaAtivo = new EventEmitter<PizzaLasanhaGrid>();
    @Output() usarPrecoPromocionalAtivo = new EventEmitter<PizzaLasanhaGrid>();
    @Output() abrirIngredientesSabor = new EventEmitter<PizzaLasanhaGrid>();

    constructor(
        private modalController: ModalController,
    ) { }

    public indexSelecionado: number = null;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['pizzaLasanha'] || changes['sabores'] || changes['tamanhos']) {
            if (this.indexSelecionado != null) {
                this.focarInputIndex(this.indexSelecionado);
            }
        }
    }

    public alterarItemSelecionado(index: number) {
        this.alterarIndexItemSelecionado.emit(index);
    }

    // public focarProximoInput(rowIndex: number, colIndex: number) {
    //     console.log(this.tamanhos);
    //     console.log(rowIndex);
    //     console.log(colIndex);

    //     console.log(this.pizzaLasanha);


    //     let inputsArray = this.inputs.toArray();
    //     const indexAtual = rowIndex * this.tamanhos.length + colIndex;
    //     console.log(indexAtual);

    //     const proximoIndex = indexAtual + 1;

    //     if (proximoIndex < this.inputs.length) {   
    //         console.log(inputsArray);

    //         (rowIndex - 1)
    //         inputsArray[proximoIndex].nativeElement.focus();
    //     } else {
    //         this.alterarItemSelecionado(this.indexItemSelecionado + 1);

    //         setTimeout(() => {
    //             inputsArray = this.inputs.toArray();
    //             inputsArray[0].nativeElement.focus();
    //         });
    //     }
    // }


    public focarProximoInput(event: any) {
        event.preventDefault();

        const elementoAtual = event.target as HTMLInputElement;
        const inputsArray = this.inputs.toArray();
        const indexAtual = inputsArray.findIndex(el => el.nativeElement === elementoAtual);
        const proximoIndex = indexAtual + 1;

        this.indexSelecionado = proximoIndex;

        if (proximoIndex < inputsArray.length) {
            inputsArray[proximoIndex].nativeElement.focus();
        } else {
            inputsArray[0].nativeElement.focus();
        }
    }

    private focarInputIndex(index: number) {
        setTimeout(() => {
            if (this.inputs == undefined) return;

            const inputsArray = this.inputs.toArray();

            if (index < inputsArray.length) {
                inputsArray[index].nativeElement.focus();
            } else {
                inputsArray[0].nativeElement.focus();
            }
        }, 0)
    }


    //   public alterarValorPizza(pizzaLasanha: ProdutoPizzaLasanhaComEmpresa) {    
    //     this.alterarPizza.emit([pizzaLasanha]);
    //   }

    public alterarValorPizza(pizzaLasanha: ValoresPorSabor) {
        this.alterarPizza.emit(pizzaLasanha);
    }

    // public alterarCheckedPizzaLasanha(pizzaLasanha: ProdutosPizzaLasanhaComEmpresa) {
    //     this.checkedPizzaLasanha.emit([pizzaLasanha]);
    // }

    public alterarCheckedPizzaLasanha(pizzaLasanha: PizzaLasanhaGrid) {
        this.pizzaLasanhaAtivo.emit(pizzaLasanha);
    }

    public alterarStatusUsarPrecoPromocional(sabor: PizzaLasanhaGrid) {        
        this.pizzaLasanhaAtivo.emit(sabor);
    }

    public abrirIngredientes(sabor: PizzaLasanhaGrid) {        
        this.abrirIngredientesSabor.emit(sabor);
    }

    public qtdSaboresFatias(tamanho: Tamanho) {
        const produtoPizzaLasanhaQtdSabor = this.produtosPizzaLasanhaQtdSabores.find((produto) => produto.codigoProdutosCategorias === tamanho.codigoCategoria);
        // const produtoPizzaLasanhaQtdFatia = this.produtosPizzaLasanhaQtdSabores
        
        if (produtoPizzaLasanhaQtdSabor === null) {
            return;
        }
        
        this.modalController.create({
            component: QtdSaboresFatiasComponent,
            componentProps: {
                codigoCategoria: tamanho.codigoCategoria,
                produtoPizzaLasanhaQtdSabor: { ...produtoPizzaLasanhaQtdSabor },
                tamanho: tamanho
            }
        }).then((modal) => modal.present());
    }
}
